import {useState, useEffect} from 'react';

const StabRules = {
	"audi_nl": {
		"payload": {
			"ClientMarket": "nl",
			"disableIngress": true
		},
		"periods": null,
		"priority": 1
	},
	"canamoffroad-north-america": {
		"payload": {
			"displayName": "CAN-AM North America 3D rates",
			"allowRatesEdit": true,
			"ClientMarket": ["US", "MX"],
			"ClientApplication": ["canamoffroad"],
			"perCar": {
				"can-am defender 2020": 100,
				"can-am commander 2020": 50
			}
		},
		"periods": null,
		"priority": 10
	},
	"canam-eu": {
		"payload": {
			"allowRatesEdit": true,
			"ClientMarket": ["BL", "DE"],
			"ClientApplication": ["canamoffroad", "camononroad"],
			"perCar": {
				"can-am maverick 2020": 20,
				"can-am outlander 2020": 100,
				"can-am.renegade 2020": 50,
				"can-am ssp 2020": 30
			}
		},
		"periods": null,
		"priority": 10
	}
};

const SIMULATE_TIMEOUT = 2000;

function wait(t) {
	return new Promise(function (res) {
		setTimeout(res, t);
	});
}

async function listRules() {
	await wait(SIMULATE_TIMEOUT);
	return StabRules;
}

async function loadRule(ruleId) {
	await wait(SIMULATE_TIMEOUT);
	return Object.assign({ruleId}, StabRules[ruleId]);
}

async function saveRule(ruleId, rule) {
	await wait(SIMULATE_TIMEOUT);
	StabRules[ruleId] = {payload: rule, periods: rule, priority: 10};
	return rule;
}

async function deleteRule(ruleId) {
	await wait(SIMULATE_TIMEOUT);
	delete StabRules[ruleId];
}

function useRulesData(load) {
	let [data, setData] = useState(null);
	let [loading, setLoading] = useState(false);
	useEffect(() => {
		if (data === null) {
			setLoading(true);
			(async () => {
				let d = await load();
				setData(d);
				setLoading(false);
			})();
		}
	});
	return [loading, data, setData];
}

export default StabRules;
export {listRules, loadRule, saveRule, deleteRule, useRulesData};
